import { Bar, mixins } from 'vue-chartjs'
import { throws } from 'assert';
const { reactiveProp } = mixins

export default {
	extends: Bar,
	mixins: [reactiveProp],
	props: ['axislabel', 'color', 'chartData', 'chartLabels', 'type'],
	data () {
		return {
			gradient: null,
			data:this.chartData,
			borderColor: '',
			labels:[],
			options: {
				responsive: true,
				maintainAspectRatio: false,
				legend: {
						display: false
				},
				tooltips: {
						enabled: false
				},
				elements: { point: { radius: 0 } },
				scales: {
					yAxes: [{
						ticks: {
							beginAtZero: true
						},
						scaleLabel: {
							display: true,
							labelString: this.axislabel,
							fontSize: 18
						}
					}],
					xAxes: [{
						scaleLabel: {
							display: true,
							labelString: 'Date',
							fontSize: 18
						}
					}]
				},
				events: []
			}
		}
	},
	watch: {
		data: {
			handler: function(val, oldVal) {// watching for chart data change
				this.$data._chart.update()
			},
			deep: true
		}
	},
	mounted () {
		this.renderChartQ()
	},
	methods: {
		renderChartQ: function(){
			this.getLabels() // checking if labels are exist
			this.renderChart( // setting chart data and styling, then render
				{
					labels: this.labels,
					datasets: [
						{
							backgroundColor: '#B5CE42',
							borderColor: '#B5CE42',
							borderWidth: 0,
							pointBorderColor: 'white',
							pointBackgroundColor: 'white',
							data: this.data
						}
					]
				},
				Object.assign(this.options)
			)
		},
		getLabels: function() {
			if(!this.chartLabels && this.type != 'multi') {
				let i = 0
				this.chartData.map(chart => {
					this.labels.push(i++)
				})
			} else {
				this.labels = []
				this.labels = this.chartLabels
			}
		}
	}
}